module.exports = __webpack_public_path__ + "img/bg_police_02.7b1c8a58.png";